import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, ChevronDown } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();
  // Check if we're on the homepage
  const isHome = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
  }, [location.pathname]);
  const navBgClass = isHome ? isScrolled ? 'bg-navy shadow-lg py-3' : 'bg-transparent py-5' : 'bg-navy shadow-lg py-3';
  const services = [{
    name: 'All Services',
    path: '/services'
  }, {
    name: 'Residential Soft Washing',
    path: '/services/residential'
  }, {
    name: 'Roof Cleaning',
    path: '/services/roof'
  }, {
    name: 'Gutter Cleaning',
    path: '/services/gutter'
  }, {
    name: 'Driveway & Concrete',
    path: '/services/driveway'
  }, {
    name: 'Deck & Patio',
    path: '/services/deck'
  }, {
    name: 'Fence Cleaning',
    path: '/services/fence'
  }, {
    name: 'Commercial Soft Washing',
    path: '/commercial'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${navBgClass}`} data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="flex justify-between items-center" data-id="element-121">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/5AVKXiTXV1VVA3kGuFBhc2/TheSoftwashPros-logo.jpg" alt="Softwash Pros Logo" className="h-14 md:h-20 rounded-xl" data-id="element-123" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-124">
            <Link to="/" className="text-white hover:text-light-blue font-semibold transition-colors" data-id="element-125">
              Home
            </Link>
            <Link to="/about" className="text-white hover:text-light-blue font-semibold transition-colors" data-id="element-126">
              About Us
            </Link>

            {/* Services Dropdown */}
            <div className="relative group" onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-127">
              <button className="flex items-center text-white hover:text-light-blue font-semibold transition-colors py-2" data-id="element-128">
                Services <ChevronDown className="w-4 h-4 ml-1" data-id="element-129" />
              </button>

              {isServicesOpen && <div className="absolute top-full left-0 w-64 bg-white rounded-md shadow-xl py-2 border border-gray-100" data-id="element-130">
                  {services.map((service, idx) => <Link key={idx} to={service.path} className="block px-4 py-2 text-sm text-navy hover:bg-cream hover:text-navy transition-colors" data-id="element-131">
                      {service.name}
                    </Link>)}
                </div>}
            </div>

            <Link to="/gallery" className="text-white hover:text-light-blue font-semibold transition-colors" data-id="element-132">
              Gallery
            </Link>
            <Link to="/contact" className="text-white hover:text-light-blue font-semibold transition-colors" data-id="element-133">
              Contact
            </Link>
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-134">
            <a href="tel:586-298-2727" className="flex items-center text-white font-bold hover:text-light-blue transition-colors" data-id="element-135">
              <Phone className="w-5 h-5 mr-2" data-id="element-136" />
              586-298-2727
            </a>
            <Link to="/contact" className="bg-light-blue text-dark font-bold py-2 px-6 rounded hover:bg-white transition-colors" data-id="element-137">
              Get a Free Quote
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-138">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-light-blue focus:outline-none" data-id="element-139">
              {isMobileMenuOpen ? <X className="h-8 w-8" data-id="element-140" /> : <Menu className="h-8 w-8" data-id="element-141" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-navy border-t border-steel-blue/30 absolute w-full shadow-xl" data-id="element-142">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-143">
            <Link to="/" className="block px-3 py-3 text-white font-semibold hover:bg-steel-blue/20 rounded" data-id="element-144">
              Home
            </Link>
            <Link to="/about" className="block px-3 py-3 text-white font-semibold hover:bg-steel-blue/20 rounded" data-id="element-145">
              About Us
            </Link>

            <div className="px-3 py-2" data-id="element-146">
              <div className="text-light-blue font-semibold mb-2 uppercase text-sm tracking-wider" data-id="element-147">
                Services
              </div>
              <div className="pl-4 space-y-2 border-l-2 border-steel-blue/30" data-id="element-148">
                {services.map((service, idx) => <Link key={idx} to={service.path} className="block py-2 text-white/90 text-sm hover:text-white" data-id="element-149">
                    {service.name}
                  </Link>)}
              </div>
            </div>

            <Link to="/gallery" className="block px-3 py-3 text-white font-semibold hover:bg-steel-blue/20 rounded" data-id="element-150">
              Gallery
            </Link>
            <Link to="/contact" className="block px-3 py-3 text-white font-semibold hover:bg-steel-blue/20 rounded" data-id="element-151">
              Contact
            </Link>

            <div className="mt-6 pt-6 border-t border-steel-blue/30 px-3 flex flex-col space-y-4" data-id="element-152">
              <a href="tel:586-298-2727" className="flex items-center justify-center text-white font-bold text-lg" data-id="element-153">
                <Phone className="w-5 h-5 mr-2 text-light-blue" data-id="element-154" />
                586-298-2727
              </a>
              <Link to="/contact" className="bg-light-blue text-dark font-bold py-3 px-6 rounded text-center w-full" data-id="element-155">
                Get a Free Quote
              </Link>
            </div>
          </div>
        </div>}
    </nav>;
}